<template>
    <div class="row" v-if="!hasProfilePermissions">
        <sau-request-permission></sau-request-permission>
    </div>
    <div v-else>
        <div v-if="!this.ready">
            <sau-loading slot="credit stuff"></sau-loading>
        </div>

        <div class="prepay" v-else>

            <template v-if="! complete">

                <div class="row" v-if="error">
                    <div class="col">{{ error }}</div>
                </div>
                <!-- <div class="row mt-5" v-else> -->

                <div v-else class="flex flex-wrap">
                    <div class="w-full pb-8 md:w-1/2 lg:w-2/3 md:pr-4">
                        <template>
                            <p class="mt-3">{{ prepayMessage }}</p>
                        </template>
                        <div class="domain-banner">
                            <div class="flex w-full h-100">
                                <div class="pt-4 px-4 sm:pt-8 sm:px-8 w-full lg:py-0 lg:w-2/3 lg:ml-auto d-flex flex-column mb-5 domain-banner-content">
                                    <nav class="sau-menu-horizontal md mt-3 mb-8">
                                        <ul>
                                            <li class="d-block d-md-inline-block">
                                                <a href="javascript:void(0)" @click="switchView()" :class="{active: customAmountView === false}" title="Choose Prepayment Term">Choose Term</a>
                                            </li>
                                            <li class="d-block d-md-inline-block mt-3 mt-md-0">
                                                <a href="javascript:void(0)" @click="switchView('custom')" :class="{active: customAmountView}" title="Custom Prepayment Term">Custom Amount</a>
                                            </li>
                                        </ul>
                                    </nav>

                                    <template v-if="!customAmountView">
                                        <template v-if="hasServices">
                                            <form>
                                                <label class="sr-only" for="input-prepayment-period">Prepayment Period</label>
                                                <div class="input-group mb-1 border border-light p-2">
                                                    <select v-model="selectedPrepaymentPeriod" id="input-prepayment-period" class="form-control sm:text-xl px-3 bg-transparent -ml-4 px-3 pr-1 sm:pr-3 focus-0 border-0 centered-select">
                                                        <option v-for="(option, index) in thresholds" :key="index" :value="index">{{ option.timeframe }}</option>
                                                    </select>
                                                </div>
                                            </form>
                                            <div>
                                                <div v-if="selectedThreshold && selectedThreshold.percentage" class="text-center text-xl">
                                                    You Save:
                                                    <span class="text-success sau-font-bold text-2xl">{{ selectedThreshold.percentage }}%</span>
                                                </div>
                                            </div>
                                        </template>
                                        <template v-else>
                                            <p>As payment terms are based on your monthly spend, you need to have live services in your account to use this option.</p><p>Try a Custom Amount instead!</p>
                                        </template>
                                    </template>

                                    <template v-else>
                                        <form>
                                            <label class="sr-only" for="input-custom-amount">Custom Amount</label>
                                            <div class="input-group mb-1 border border-light p-2">
                                                <money v-model="customAmount" v-bind="money" class="form-control text-base sm:text-xl px-3 leading-none bg-transparent -ml-4 px-3 pr-1 sm:pr-3 focus-0 border-0"></money>
                                            </div>
                                        </form>

                                        <div class="text-center">
                                            <template v-if="currentThreshold">
                                                <p class="mb-0 text-xl">
                                                    Bonus Credit:
                                                    <span class="text-success sau-font-bold text-2xl">{{ currentThreshold.percentage }}%</span>
                                                </p>
                                            </template>
                                            <transition name="fade">
                                                <div v-if="nextThreshold && canViewNextThreshold">
                                                    <p class="mb-0 text-success">
                                                        Or earn
                                                        <span class="text-xl sau-font-bold">{{ nextThreshold.percentage }}%</span>
                                                        bonus credit by prepaying an additional {{ (nextThreshold.payment_amount - customAmount) | currency }}!
                                                    </p>
                                                    <button @click="useNextThreshold()" class="btn btn-success mt-1">Yes Please!</button>
                                                </div>
                                            </transition>
                                        </div>
                                    </template>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- <div class="md:w-1/3"> -->
                    <div class="w-full md:w-1/2 lg:w-1/3 md:pl-4">
                        <div class="border md:border-0 md:shadow-sau-lg p-8 bg-white">
                            <template>
                                <div class="text-center mb-3">
                                    <h4>Account Prepayment</h4>
                                    <i class="fal fa-piggy-bank" style="font-size: 5rem;"></i>
                                </div>

                                <div class="border-t pt-3 mb-3 text-center">
                                    <p class="text-xl w-full">Payment Method</p>
                                    <transition name="fade" mode="out-in" appear>
                                        <div>
                                            <template v-if="!paymentMethodsLoading">
                                                <div class="row prepay-methods">
                                                    <div class="col-6 mb-3" v-if="userDetails.billing.card_last_four">
                                                        <div class="method-container" @click="setMethod('creditcard')" :class="paymentMethod == 'creditcard' ? 'selected' : ''">
                                                            <img :src="getCreditCardImage()" alt="Prepay with your credit card" title="Prepay with your credit card">
                                                        </div>
                                                    </div>

                                                    <div class="col-6 mb-3" v-if="clientHasActivePaypalBA">
                                                        <!-- Vue bootstrap tooltip doesn't like being applied to a disabled button, so we need ot do it twice -->
                                                        <div v-b-tooltip.hover title="Due to PayPal's Terms, we’re unable to accept PayPal payments for anything over $10,000" v-if="!canPayWithPaypal">
                                                            <button class="method-container cursor-not-allowed" @click="setMethod('paypal')" :class="paymentMethod == 'paypal' ? 'selected' : ''" disabled>
                                                                <img src="/img/logo-paypal.gif" alt="Prepay with Paypal" title="Prepay with Paypal">
                                                            </button>
                                                        </div>
                                                        <div v-else>
                                                            <button class="method-container" @click="setMethod('paypal')" :class="paymentMethod == 'paypal' ? 'selected' : ''">
                                                                <img src="/img/logo-paypal.gif" alt="Prepay with Paypal" title="Prepay with Paypal">
                                                            </button>
                                                        </div>
                                                    </div>

                                                    <div class="col-6 mb-3">
                                                        <div class="method-container" @click="setMethod('bpay')" :class="paymentMethod == 'bpay' ? 'selected' : ''">
                                                            <img src="/img/bpay-landscape.gif" alt="Prepay with your BPAY" title="Prepay with BPAY">
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="row">
                                                    <div class="col-12" v-if="!clientHasActivePaypalBA && !userDetails.billing.card_last_four">
                                                        <a
                                                            href="/account/payment-options"
                                                            title="Add payment details to your account"
                                                            class="block w-full p-2 mb-4 text-sm border text-grey hover:border-grey-600 hover:text-grey-600 border-red text-red hover:border-red-600 hover:text-red-600"
                                                        >Add Payment Method</a>
                                                    </div>
                                                </div>
                                            </template>
                                        </div>
                                    </transition>
                                </div>

                                <div v-if="!customAmountView && hasServices">
                                    <div class="border-t pt-3">
                                        <p class="text-sm w-full text-success mb-1">
                                                Bonus credit
                                                <span class="float-right sau-font-bold">{{ selectedThreshold.discount | currency }}</span>
                                            </p>
                                            <p class="text-sm w-full text-success mb-1">
                                                You will be credited
                                                <span class="float-right sau-font-bold">{{ creditAmount | currency }}</span>
                                            </p>
                                        <p class="text-xl w-full mb-0 sau-font-bold">
                                            Total
                                            <span class="float-right">{{ selectedThreshold.threshold - selectedThreshold.discount | currency }}</span>
                                        </p>
                                    </div>
                                    <div class="mt-3">
                                        <b-form-checkbox v-model="confirmed" @change="confirmed = ! confirmed" class="text-sm my-6">
                                            Yes, I would like to prepay my account.
                                            <div v-if="paymentMethod === 'creditcard'">
                                               <strong>Payment will be taken from card ending in {{ userDetails.billing.card_last_four }}.</strong>
                                            </div>
                                        </b-form-checkbox>
                                    </div>
                                    <div class="mt-3">
                                        <div v-b-tooltip.hover :title="disablePaymentReason" v-if="disablePayment">
                                            <button @click="prepay()" class="btn btn-success d-block w-100" disabled>
                                                <template v-if="processing">Please wait...</template>
                                                <template v-else>Prepay {{ selectedThreshold.timeframe }}</template>
                                            </button>
                                        </div>
                                        <div v-else>
                                            <button @click="prepay()" class="btn btn-success d-block w-100">
                                                <template v-if="processing">Please wait...</template>
                                                <template v-else>Prepay {{ selectedThreshold.timeframe }}</template>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                                <div v-else>
                                    <div class="border-t pt-3">
                                        <template v-if="currentThreshold && currentThreshold.hasOwnProperty('discount')">
                                            <p class="text-sm w-full text-success mb-1">
                                                Bonus credit
                                                <span class="float-right sau-font-bold">{{ (customAmount * currentThreshold.percentage) / 100 | currency }}</span>
                                            </p>
                                            <p class="text-sm w-full text-success mb-1">
                                                You will be credited
                                                <span class="float-right sau-font-bold">{{ creditAmount | currency }}</span>
                                            </p>
                                        </template>

                                        <p class="text-xl w-full mb-0 sau-font-bold">
                                            Total
                                            <span class="float-right">{{ customAmount | currency }}</span>
                                        </p>
                                    </div>
                                    <div class="mt-3">
                                        <b-form-checkbox v-model="confirmed" @change="confirmed = ! confirmed" class="text-sm my-6">
                                            Yes, I would like to prepay my account
                                        </b-form-checkbox>
                                    </div>
                                    <div class="mt-3">
                                        <div v-b-tooltip.hover :title="disablePaymentReason" v-if="disablePayment">
                                            <button @click="prepay()" class="btn btn-success d-block w-100" :disabled="disablePayment">
                                                <template v-if="processing">Please wait...</template>
                                                <template v-else>Prepay Now</template>
                                            </button>
                                        </div>
                                        <div v-else>
                                            <button @click="prepay()" class="btn btn-success d-block w-100" :disabled="disablePayment">
                                                <template v-if="processing">Please wait...</template>
                                                <template v-else>Prepay Now</template>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </template>
                        </div>
                    </div>
                </div>
            </template>
            <template v-else>

                <section class="container">
                    <div class="flex w-3/4 flex-col mx-auto">
                        <h1 class="text-blue text-3xl text-center mb-8">{{ completedPrepaymentTitle }}</h1>

                        <template v-if="paymentMethod == 'bpay'">
                            <div class="flex md:flex-row flex-col items-center my-4">
                                <div class="w-full lg:w-1/2">
                                    <h4>Amount to pay: <strong class="text-success">{{ paymentAmount | currency }}</strong></h4>
                                    <p>Your prepayment credit of <strong>{{ creditAmount | currency }}</strong> will be applied after payment for <strong>{{ paymentAmount | currency }}</strong> has been received.</p>
                                    <p>Please allow 2-3 business days for your BPAY payment to be received.</p>
                                </div>
                                <div class="w-full lg:w-1/2 md:ml-6">
                                    <sau-utility-bpay></sau-utility-bpay>
                                </div>
                            </div>
                        </template>
                        <p v-else>Your prepayment credit of <strong>{{ creditAmount | currency }}</strong> has been applied and <strong>{{ paymentAmount | currency }}</strong> has been debited from your nominated payment method.</p>

                        <div class="flex justify-center mt-6">
                            <a href="/home" class="btn mr-8">Back to Dashboard</a>
                            <a v-if="paymentMethod != 'bpay'" href="/account/payment-methods" class="btn btn-success">View account credit</a>
                        </div>

                        <template v-if="paymentMethod == 'bpay'">
                            <hr class="border-green w-24 mx-auto my-12" />

                            <article>
                                <section>
                                    <h3>Paying by BPAY</h3>
                                    <p>Your prepayment credit will be applied only after your BPAY payment has been processed via your bank or financial institution.</p>
                                    <p>BPAY payments can take up to 3 business days to process. If you need to pay for your transaction immediately, please choose the Credit Card or PayPal options.</p>
                                </section>
                                <section>
                                    <h3>What happens after your BPAY payment?</h3>
                                    <p>BPAY payments can take 2-3 business days to be processed. Your prepayment credit will not be applied until we receive full payment.</p>
                                    <p>You will recieve an email from Servers Australia when your prepayment credit has been applied to your account.</p>
                                </section>
                                <section>
                                    <button class="btn btn-light" @click.prevent="resetPaymethod()">Choose another payment method instead</button>
                                </section>
                            </article>
                        </template>
                    </div>
                </section>

            </template>
        </div>
    </div>
</template>
<script>
import Money from "v-money";

export default {
    data() {
        return {
            hasServices: true,
            thresholds: {},
            error: "",
            ready: false,
            confirmed: false,
            selectedPrepaymentPeriod: null,
            paymentMethod: '',
            processing: false,
            customAmountView: false,
            customAmount: 0,
            money: {
                decimal: ".",
                thousands: ",",
                prefix: "$   ",
                precision: 2,
                masked: false
            },
            maxPaypalTransaction: 10000,
            showTooltip: true,
            nextThresholdWatcher: null,
            canViewNextThreshold: false,
            nextThresholdDelay: 400,
            hasProfilePermissions: false,
            paymentMethodsLoading: true,

            complete: false,
            result: null,
            request: {
                paymentMethod: null,
                customAmount: null,
                paymentAmount: null,
                creditAmount: null,
            },
        };
    },

    mounted() {
        this.hasProfilePermissions = this.userDetails.whmcs_contact_id ? this.userDetails.permissions.split(",").indexOf("invoices") > -1 : true;
        if (this.hasProfilePermissions) this.getPrepaymentOptions();

        const urlParams = new URLSearchParams(window.location.search);
        const paramValue = urlParams.get('type');
        if(paramValue == 'custom') {
            this.switchView('custom');
        }
    },

    activated() {
        this.hasProfilePermissions = this.userDetails.whmcs_contact_id ? this.userDetails.permissions.split(",").indexOf("invoices") > -1 : true;
        if (!this.hasProfilePermissions) return;

        const ppPromise = new Promise((resolve, reject) => {
            this.getPaypalBAState().then(response => {
                this.$store.commit("paypalActiveBAOnFile", response.data.data.baState);
                this.$store.commit("paypalActiveBAEmail", response.data.data.baEmail);
                resolve();
            }).catch(error => reject());
        })
        const ccPromise = new Promise((resolve, reject) => {
            this.getPaymentMethods().then(() => resolve()).catch(() => reject());
        })
        Promise.all([ppPromise, ccPromise]).then(() => this.paymentMethodsLoading = false);

    },

    methods: {
        getPrepaymentOptions() {
            this.getRequest("/api/accounts/prepayment")
                .then(response => {
                    if (response.data.result === "success") {
                        this.thresholds = response.data.thresholds;
                        if(this.thresholds.length < 1) {
                            // If no thresholds (no customer services) there are no discounts and they can just add credit in the custom amount view
                            this.hasServices = false;
                            this.customAmountView = true;
                        }
                    }

                    if (response.data.error) {
                        return (this.error = response.data.error);
                    }
                })
                .finally(() => {
                    if (!this.error) {
                        this.selectedPrepaymentPeriod = 24; // Preselect 24 months as the prepayment period
                    }
                    this.ready = true;
                });
        },

        prepay() {
            this.processing = true;

            this.request = {
                paymentMethod: this.paymentMethod,
                paymentAmount: this.paymentAmount,
            };


            if(this.paymentMethod === 'bpay') {
                this.complete = true;
                this.processing = false;
                window.scrollTo({ top: 0, behavior: 'smooth' });
                return;
            }

            const toast = this.$swal({
                title: "Prepaying Account",
                text: "Please wait...",
                imageUrl: "/img/spinner-dark-gray-80.gif",
                showConfirmButton: false,
                allowOutsideClick: false
            });

            this.postRequest("/api/billing/prepayment", this.request)
                .then(response => {
                    this.$swal.closeModal();

                    let errorMessage = "";
                    let error = false;

                    if (response.data.error) {
                        errorMessage = response.data.error;
                        error = true;
                    } else if (response.data.data.result != "success") {
                        errorMessage = response.data.data.message;
                        error = true;
                    }

                    if (error) {
                        this.$swal({
                            type: "error",
                            title: "Failed to Prepay Account",
                            text: errorMessage,
                            position: "center",
                            showConfirmButton: false
                        });
                    } else {

                        this.result = response.data;

                        this.$swal({
                            type: "success",
                            title: "Success",
                            text: "Account Successfully Prepaid",
                            position: "center",
                            showConfirmButton: false,
                            allowOutsideClick: false,
                            timer: 3000,
                            onClose: () => {
                                this.complete = true;
                                this.processing = false;
                                window.scrollTo({ top: 0, behavior: 'smooth' });
                            }
                        });
                    }
                })
                .catch(error => {
                    this.$swal({
                        type: "error",
                        title: "Failed to Prepay Account",
                        position: "center",
                        showConfirmButton: false
                    });
                })
                .finally(() => {
                    this.processing = false;
                });
        },

        setMethod(paymentMethod) {
            this.paymentMethod = paymentMethod;
        },

        switchView(view = null) {
            if (view === "custom") {
                return (this.customAmountView = true);
            }
            return (this.customAmountView = false);
        },

        objToArray(object) {
            return Object.keys(object).map(key => {
                return object[key];
            });
        },

        useNextThreshold() {
            this.customAmount = this.nextThreshold.payment_amount;
        },

        resetPaymethod() { // Reset the page, eg bpay completion page to select new payment method
            this.confirmed = this.complete = false;
            this.payMethod = null;
        }
    },

    computed: {
        selectedThreshold() {
            if(!this.hasServices) return null;
            return this.ready ? this.thresholds[this.selectedPrepaymentPeriod] : null;
        },

        disablePayment() {
            return !this.confirmed || !this.ready || !this.paymentMethod || this.processing || (this.customAmountView && !this.customAmount) || (!this.hasServices && !this.customAmountView) ? true : false;
        },

        disablePaymentReason() {
            if (!this.confirmed) return 'Please agree to the prepayment request above';
            if (!this.paymentMethod) return 'Please select a payment method';
            if (this.customAmountView && this.customAmount <= 0) return 'Please enter an amount to prepay';
        },

        /**
         * Returns the current matched prepayment threshold
         */
        currentThreshold() {
            if (!this.thresholds) return; // Wait till thresholds have been loaded
            if(!this.hasServices) return;
            let thresholds = this.objToArray(this.thresholds); // Convert to array

            let current = thresholds.reduce((prev, cur) => {
                // Find closest threshold that has been met
                return cur.payment_amount <= this.customAmount ? cur : prev;
            });

            if (this.customAmount >= current.payment_amount) {
                // Return the threshold (discount, amount, period, etc)
                return current;
            }

            return null;
        },
        /**
         * Returns the next prepayment threshold if the custom amount input is within 25% of the threshold
         */
        nextThreshold() {
            if (!this.thresholds) return;
            if(!this.hasServices) return; // No services means no thresholds or discounts
            let thresholds = this.objToArray(this.thresholds);

            let nextThreshold = thresholds.reduce((prev, cur) => {
                return Math.abs(cur.payment_amount - this.customAmount) < Math.abs(prev.payment_amount - this.customAmount) ? cur : prev;
            });

            if (nextThreshold === this.currentThreshold) {
                return null;
            }

            if (this.customAmount / nextThreshold.payment_amount >= 0.75) {
                this.nextThresholdWatcher = null;
                this.nextThresholdWatcher = nextThreshold;

                return nextThreshold;
            }

            return null;
        },

        /**
         * if the transaction is above 10,000 (Paypal max tranasction) we unset the payment method and provide a notification.
         * Don't default to credit card, it may not be obvious to users
         */
        canPayWithPaypal() {
            if (this.customAmountView && this.customAmount <= this.maxPaypalTransaction) return true;

            if(!this.hasServices) return false; // No services means no thresholds or discounts and the paypal thresholds has already been checked
            if (!this.customAmountView && this.selectedThreshold.threshold <= this.maxPaypalTransaction) return true;

            if (this.paymentMethod === "paypal") {
                this.setMethod(null);
            }

            return false;
        },

        payingCustomAmount() {
            return this.customAmountView;
        },

        completedPrepaymentTitle() {
            return this.paymentMethod == 'bpay' ?
                'Complete your Prepayment with BPAY'    :
                'Your Prepayment has been completed';
        },

        paymentAmount() {
            if(this.payingCustomAmount) {
                return this.customAmount;
            } else {
                if(!this.hasServices) return;
                return this.selectedThreshold.payment_amount;
            }
        },

        creditAmount() {
            if(this.payingCustomAmount) {
                if(!this.hasServices) {
                    return this.customAmount;
                }
                return this.customAmount + (this.customAmount * this.currentThreshold.percentage) / 100;
            } else {
                if(!this.hasServices) return;
                return this.selectedThreshold.threshold;
            }
        },

        prepayMessage() {
            if(!this.hasServices) {
                return 'Add credit to your account that can be used for any new or existing services.';
            }

            return this.customAmountView
                ? 'Your bonus is based on your current monthly spend, but your credit can be used for any existing and new purchases!'
                : 'Your payments are based on your current monthly spend, but your credit can be used for any existing and new purchases!';
        },

    },

    watch: {
        nextThresholdWatcher: {
            // Delay the display of the next available threshold by 400ms
            handler: function() {
                if(!this.hasServices) return false;
                // can't use arrow functions without rebiding state
                this.canViewNextThreshold = false;
                setTimeout(() => {
                    this.canViewNextThreshold = true;
                }, this.nextThresholdDelay);
            }
        }
    }
};
</script>
<style lang="scss" scoped>
select {
    -moz-appearance: auto !important;
    -webkit-appearance: auto !important;
}
.suggestion {
    &:hover {
        box-shadow: 0 0 2px config("colors.blue");
    }
    &.selected,
    &:hover {
        &,
        * {
            color: config("colors.blue") !important;
            border-color: config("colors.blue") !important;
        }
    }
}

// --breakpoint-lg
@media (min-width: 992px) {
    .domain-banner {
        background-image: url("/img/apiro-claim-banner.png");
        background-size: cover;
        background-repeat: no-repeat;
        height: 325px;
        background-position: bottom;
        background-size: 100%;
    }
}

.prepay {
    .prepay-methods {
        .method-container {
            border: solid 2px #dedede;
            border-radius: 5px;
            width: 100%;
            padding: 5px;
            display: flex;
            align-items: center;
            justify-content: center;
            height: 70px;

            &:hover {
                cursor: pointer;
            }

            &.selected,
            &:hover {
                border: solid 2px #00ce7d;
                box-shadow: 2px 2px 2px rgba(0, 0, 0, 0.25);
            }

            &:focus {
                outline: none;
            }

            &:disabled {
                -webkit-filter: grayscale(100%);
                filter: grayscale(100%);
            }
        }
        img {
            max-width: 75%;
            max-height: 85%
        }
    }
}
.centered-select {
    text-align-last: center; // Chrome
    text-align: center; // FF
}
.sau-menu-horizontal {
    li {
        text-align: center;
        font-size: 1.25rem;

        a {
            padding: 0.33rem 0.5rem;

            &:hover,
            &.active {
                color: #00ce7d !important;
            }
            &.active {
                border: solid 2px #00ce7d;
                border-radius: 0.25rem;
            }
        }
    }
}
</style>
